import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Columns, Container } from '../../elements'
import Cookies from 'js-cookie'
import './footer.css'
import moment from 'moment'
import MailchimpSubscribe from 'react-mailchimp-subscribe'
import { subscribeUser } from './../../elements/klaviyoTracking/userSignUp'

const url =
  'https://twistedroad.us15.list-manage.com/subscribe/post?u=a17a04ce04f77ac96298e2383&id=a176916d03'

const CustomForm = ({ status, message, onValidated }) => {
  let email
  const submit = () => {
    if (email) {
      subscribeUser(email.value)
    }
    email &&
      email.value.indexOf('@') > -1 &&
      onValidated({
        EMAIL: email.value,
      })
  }

  return (
    <div>
      <input
        className="footer-subscribe-email-input"
        ref={(node) => (email = node)}
        type="email"
        placeholder="Email Address"
      />
      <button onClick={submit}>Subscribe</button>

      {status === 'error' && (
        <div
          className="mailchimp-message has-text-danger"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {status === 'success' && (
        <div className="mailchimp-message has-text-success">
          <i className="far fa-check-circle has-text-success"></i> Thanks! You
          were successfully subscribed to our newsletter.
        </div>
      )}
    </div>
  )
}

class Footer extends Component {
  constructor() {
    super()
    this.state = {
      europian: undefined
    }
  }

  componentDidMount() {
    const userRegion = Cookies.get('userRegion')
    const userIPAddress = Cookies.get('userIPAddress')
    if (!userIPAddress || !userRegion) {
      fetch('https://ipinfo.io/json')
        .then(res => {
          return res.json()
        })
        .then(data => {
          let timeZone = data.timezone.toLowerCase()
          this.setState({
            europian: timeZone.includes('europe')
          })
          Cookies.set('userRegion', timeZone)
          Cookies.set('userIPAddress', data.ip)
        })
        .catch(error => {
          console.log("Failed to fetch IP Info", error)
          this.setState({
            europian: false
          })
        })
    } else {
      this.setState({
        europian: userRegion
      })
    }
  }

  render() {
    const isEventsPage = this.props.location.pathname === '/events'
    const { europian } = this.state

    return (
      <div className={`main-footer-wrap${isEventsPage ? ' mt-0' : ''}`}>
        <Container className="medium">
          <Columns breakpoint="mobile">
            <Columns.Column
              mobile={{ size: 12 }}
              tablet={{ size: 2 }}
              className="mobileFooterContainer"
            >
              <span className="footer-header">Learn More</span>
              <ul className="footer-menu">
                <li>
                  <a href="/how-it-works">How It Works</a>
                </li>
                <li>
                  <a href="/reviews">Customer Reviews</a>
                </li>
                <li>
                  <a href="https://support.twistedroad.com" target="_blank">Help Center</a>
                </li>
                <li>
                  <a href="/20-point-inspection">20-point Inspection</a>
                </li>
                <li>
                  <a href="/how-it-works/insurance">Insurance</a>
                </li>
                <li>
                  <a href="/about-us">About Us</a>
                </li>
                <li>
                  <a href="/one-two-free">Ride For Free</a>
                </li>
                <li>
                  <a href="/list-your-motorcycle">List Your Bike</a>
                </li>
                <li>
                  <a href="/list-your-motorcycle/calculator">Estimate Rental Income</a>
                </li>
                <li>
                  <a href="/search">Rent a Motorcycle</a>
                </li>
                <li>
                  <a href="/referrals/invite">Give a Free Day, Get $25</a>
                </li>
                <li>
                  <a href="/referrals/redeem">Redeem a Referral</a>
                </li>
                <li>
                  <a href="/riders-preferred-membership">Riders Preferred Membership</a>
                </li>
                <li>
                  <a href="/foremost-insurance">Foremost Insurance</a>
                </li>
              </ul>
            </Columns.Column>

            <Columns.Column
              mobile={{ size: 6 }}
              tablet={{ size: 2 }}
              className="footer-cities-wrap"
            >
              <Columns breakpoint={'mobile'}>
                <Columns.Column
                  mobile={{ size: 12 }}
                  tablet={{ size: 12 }}
                  className="mobileFooterContainer"
                >
                  <span className="footer-header">Popular Cities</span>
                  <ul className="footer-menu">
                    <li>
                      <a href="/locations/los-angeles">Los Angeles, CA</a>
                    </li>
                    <li>
                      <a href="/locations/las-vegas">Las Vegas, NV</a>
                    </li>
                    <li>
                      <a href="/locations/orlando">Orlando, FL</a>
                    </li>
                    <li>
                      <a href="/locations/tampa">Tampa, FL</a>
                    </li>
                    <li>
                      <a href="/locations/miami">Miami, FL</a>
                    </li>
                    <li>
                      <a href="/locations/ft-lauderdale">Ft Lauderdale, FL</a>
                    </li>
                    <li>
                      <a href="/locations/clearwater">Clearwater, FL</a>
                    </li>
                    <li>
                      <a href="/locations/daytona-beach">Daytona Beach, FL</a>
                    </li>
                    <li>
                      <a href="/locations/san-diego">San Diego, CA</a>
                    </li>
                    <li>
                      <a href="/locations/seattle">Seattle, WA</a>
                    </li>
                    <li>
                      <a href="/locations/nashville">Nashville, TN</a>
                    </li>
                    <li>
                      <a href="/locations/san-francisco">San Francisco, CA</a>
                    </li>
                    <li>
                      <a href="/locations/phoenix">Phoenix, AZ</a>
                    </li>
                    <li>
                      <a href="/locations/kansas-city">Kansas City, MO</a>
                    </li>
                    <li>
                      <a href="/locations/austin">Austin, TX</a>
                    </li>
                    <li>
                      <a href="/locations/houston">Houston, TX</a>
                    </li>
                    <li>
                      <a href="/locations/dallas">Dallas, TX</a>
                    </li>
                    <li>
                      <a href="/locations/san-antonio">San Antonio, TX</a>
                    </li>
                    <li>
                      <a href="/locations/portland">Portland, OR</a>
                    </li>
                    <li>
                      <a href="/locations/salt-lake-city">Salt Lake City, UT</a>
                    </li>
                    <li>
                      <a href="/locations/chicago">Chicago, IL</a>
                    </li>
                    <li>
                      <a href="/locations/denver">Denver, CO</a>
                    </li>
                    <li>
                      <a href="/locations/atlanta">Atlanta, GA</a>
                    </li>
                    <li>
                      <a href="/locations/honolulu">Honolulu, HI</a>
                    </li>
                  </ul>
                </Columns.Column>
              </Columns>
            </Columns.Column>

            <Columns.Column
              mobile={{ size: 6 }}
              tablet={{ size: 2 }}
              className="footer-cities-wrap"
            >
              <Columns breakpoint={'mobile'}>
                <Columns.Column
                  mobile={{ size: 12 }}
                  tablet={{ size: 12 }}
                  className="mobileFooterContainer"
                >
                  <span className="footer-header">Popular Brands</span>
                  <ul className="footer-menu">
                    <li>
                      <a href="/brand/harley-davidson-rental">
                        Harley-Davidson
                      </a>
                    </li>
                    <li>
                      <a href="/brand/triumph-rental">Triumph</a>
                    </li>
                    <li>
                      <a href="/brand/bmw-rental">BMW</a>
                    </li>
                    <li>
                      <a href="/brand/ducati-rental">Ducati</a>
                    </li>
                    <li>
                      <a href="/brand/honda-rental">Honda</a>
                    </li>
                    <li>
                      <a href="/brand/indian-rental">Indian</a>
                    </li>
                    <li>
                      <a href="/brand/yamaha-rental">Yamaha</a>
                    </li>
                    <li>
                      <a href="/brand/suzuki-rental">Suzuki</a>
                    </li>
                    <li>
                      <a href="/brand/ktm-rental">KTM</a>
                    </li>
                    <li>
                      <a href="/brand/kawasaki-rental">Kawasaki</a>
                    </li>
                  </ul>
                </Columns.Column>
              </Columns>
            </Columns.Column>

            <Columns.Column size={6} className="footer-social-column">
              <div className="footer-social-inner">
                <span className="footer-header">Stay In Touch</span>

                <ul className="footer-menu contact-us">
                  <li>
                    <a href="/contact-us">Contact Us</a>
                  </li>
                  <li>
                    <a
                      href="https://support.twistedroad.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Help Center
                    </a>
                  </li>
                  <li>
                    <a href="/blog">Read Our Blog</a>
                  </li>
                </ul>

                <span className="footer-header subscribe">
                  Subscribe to get special offers, moto inspiration, and more.
                </span>
                <div className="footer-subscribe-email">
                  <MailchimpSubscribe
                    url={url}
                    render={({ subscribe, status, message }) => (
                      <CustomForm
                        status={status}
                        message={message}
                        onValidated={(formData) => subscribe(formData)}
                      />
                    )}
                  />
                </div>

                <div className="social-icons">
                  <a
                    href="https://www.instagram.com/twistedroad/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="fa-stack fa-2x">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-instagram fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                  <a
                    href="https://twitter.com/twistedroad_"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="fa-stack fa-2x">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-twitter fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                  <a
                    href="https://www.facebook.com/ridetwistedroad/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="fa-stack fa-2x">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-facebook-f fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                  <a
                    href="mailto:info@twistedroad.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="fa-stack fa-2x">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fal fa-envelope fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                </div>
              </div>

              <div className="col-xs-12">
                <div className="sub-footer-copyright-wrap">
                  <div className="copy-left-column">
                    <br />
                    <a href="/privacy-policy">Privacy Policies</a>
                    <br />
                    <a href="/terms-conditions">Terms of Service</a>
                    <br />
                    <a href="/extended-test-ride-terms-of-service">
                      Extended Test Ride Terms of Service
                    </a>
                    <br />
                    <a href="/other-policies">Other Policies</a>
                    <br />
                    {europian &&
                      <a
                        onClick={(e) => {
                          e.preventDefault()
                          window.displayPreferenceModal()
                        }}
                        id="termly-consent-preferences">
                          Consent Preferences
                      </a>
                    }
                    <br />
                    <br />© Copyright {moment().format('YYYY')} Twisted Road - 1001 Green Bay Road, Suite 300, Winnetka, IL 60093.
                    All rights reserved.
                  </div>
                </div>
              </div>
            </Columns.Column>
          </Columns>
        </Container>
      </div>
    )
  }
}

export default withRouter(Footer)
